<template>
  <div>
    <div class="tieebg" style="margin-left='300px'">
      {{ day }}:{{ hour }}:{{ min }}:{{ second }}
    </div>
  </div>
</template>
 
<script>
export default {
  data() {
    return {
      // 倒计时-时
      hour: "",
      // 倒计时-分
      min: "",
      // 倒计时-秒
      second: "",
      // 倒计时-时间
      countSecond: "",
      // 结束日期
      endDate: "",
    };
  },
  created() {
    // 倒计时调用
    this.countTime();
  },
  methods: {
    // 倒计时
    countTime() {
      let now = new Date(); // 获取当前时间
      // let endDate = new Date(this.endDate); // 设置截止时间
      this.endDate = new Date("2025-05-10T11:00:00");
      //let endDate = new Date(this.assistActivityEndTime); // this.assistActivityEndTime需要倒计时的日期
      let leftTime = this.endDate - now; // 倒计时时间差
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        let dayh = this.day * 24;
        // 时
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        h = h;
        this.hour = h < 10 ? "0" + h : h;
        // 分
        let m = Math.floor((leftTime / 1000 / 60) % 60);
        this.min = m < 10 ? "0" + m : m;
        // 秒
        let s = Math.floor((leftTime / 1000) % 60);
        this.second = s < 10 ? "0" + s : s;
        // console.log(this.day, 99999999);
        this.hour = this.day * 24 + this.hour;
        // console.log(this.hour, 789789);

        // this.hour = this.day * 24 + this.hour;
        // console.log(this.hour, 8888);

        this.countSecond = this.hour + ":" + this.min + ":" + this.second;
      } else {
        this.day = 0;
        this.hour = "00";
        this.min = "00";
        this.second = "00";
        this.countSecond = this.hour + ":" + this.min + ":" + this.second;
      }
      // 等于0的时候不调用
      if (
        this.day === 0 &&
        this.hour === 0 &&
        this.min === 0 &&
        this.second === 0
      ) {
        this.$route.query.count = 4;
        // 执行飞行任务

        return;
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        setTimeout(this.countTime, 1000);
      }
    },
  },
};
</script>


<style scoped>
.tieebg {
  margin-left: 200px;
}
</style>